import {
  WrapperStyled,
  TitleStyled,
  ListStyled,
  ListItemStyled,
  IconStyled,
  TextStyled,
  EmojiStyled,
} from './styled';

type AdvantagesProps = {
  title?: string;
  list: Array<{
    icon: string;
    text: string;
  }>;
  listDecorationEmoji?: string;
  className?: string;
};

const Advantages = ({ title, list, listDecorationEmoji, className }: AdvantagesProps) => {
  return (
    <WrapperStyled className={className}>
      {title && <TitleStyled>{title}</TitleStyled>}
      <ListStyled>
        {list.map(({ icon, text }) => (
          <ListItemStyled key={text}>
            <IconStyled name={icon} width={24} height={24} />
            <TextStyled>{text}</TextStyled>
          </ListItemStyled>
        ))}
        {listDecorationEmoji && <EmojiStyled>{listDecorationEmoji}</EmojiStyled>}
      </ListStyled>
    </WrapperStyled>
  );
};

export default Advantages;
